import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const inventorySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("General", {
          context:
            "merchant settings label for general inventory configuration",
        });
      },
      permission: settingsPagePermission("inventory-management/general"),
    },
    path: "inventory-management/general",
    lazy: async () => {
      const { InventoryManagementGeneralSettingsPage } =
        await import("../../../../setting/inventory-management/general-settings");
      return { Component: InventoryManagementGeneralSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Purchase orders", {
          context: "merchant settings label for inventory purchase orders",
        });
      },
      permission: settingsPagePermission(
        "inventory-management/purchase-orders",
      ),
    },
    path: "inventory-management/purchase-orders",
    lazy: async () => {
      const { PurchaseOrderSettingsPage } =
        await import("../../../../setting/inventory-management/purchase-order-settings");
      return { Component: PurchaseOrderSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Sales channels", {
          context: "merchant settings label for sales channel inventory sync",
        });
      },
      permission: settingsPagePermission("inventory-management/sales-channels"),
    },
    path: "inventory-management/sales-channels",
    lazy: async () => {
      const { SalesChannelInventorySettingsPage } =
        await import("../../../../setting/inventory-management/sales-channel-inventory-settings");
      return { Component: SalesChannelInventorySettingsPage };
    },
  },
  {
    handle: {
      breadcrumb: "QuickBooks Online",
      permission: settingsPagePermission("inventory-management/accounting"),
    },
    path: "inventory-management/quickbooks",
    children: [
      {
        index: true,
        lazy: async () => {
          const { QuickBooksIntegrationSettingsPage } =
            await import("../../../../setting/inventory-management/quickbooks-integration-settings");
          return { Component: QuickBooksIntegrationSettingsPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("{{integrationName}} account mappings", {
              integrationName: "QuickBooks",
              context:
                "merchant settings breadcrumb for mapping QuickBooks accounting accounts",
            });
          },
        },
        path: "account-mapping",
        lazy: async () => {
          const { QuickBooksAccountMappingPage } =
            await import("../../../../setting/inventory-management/quickbooks-account-mapping");
          return { Component: QuickBooksAccountMappingPage };
        },
      },
    ],
  },
];
